import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import './style.scss';

const NodeProductTeaser = ({ entity }) => {
  const title = entity.getIn(['title', 0, 'value']);
  const imgSrc = entity.getIn(['field_media', 0, 'styles', 'cropped_small_3_2']);
  const imgAlt = entity.getIn(['field_media', 0, 'alt']);
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE));
  const path = entity.getIn(['paths', currentLanguage]);
  const lottieAnimation = useRef(null);

  const onMouseEnter = (e) => {
    if (lottieAnimation && lottieAnimation.current) {
      lottieAnimation.current.play();
    }
  };

  return (
    <div className="NodeProductTeaser" onMouseEnter={onMouseEnter}>
      <div className="NodeProductTeaser__image_wrapper">
        <Image
          lazyload={false}
          className="NodeProductTeaser__image"
          src={imgSrc}
          alt={imgAlt}
        />
      </div>
      <div className="NodeProductTeaser__content">
        <CoreLink className="NodeProductTeaser__content__title" href={path}>
          <h2>{title}</h2>
          <i className="icon icon-arrow" />
        </CoreLink>
      </div>
    </div>
  );
};

export default NodeProductTeaser;
